import * as Yup from 'yup';

// ----------------------------------------------------------------------

export const ShopifyFormSchema = Yup.object().shape({
  baseUrl: Yup.string().required('Preenchimento Obrigatório'),
});

export type TShopifyConfigFormSchema = Yup.InferType<typeof ShopifyFormSchema>;

export const shopifyConfigFormSchemaDefaultValues: TShopifyConfigFormSchema = {
  baseUrl: '',
};
